;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"_8ObX9sGejgxVbewdpt8a"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs'

if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_URL.includes('dev')) {
	Sentry.init({
		dsn: process.env.NEXT_PUBLIC_SENTRY_URL,
		tracesSampleRate: 1,
		debug: false,
		// replaysOnErrorSampleRate: 1.0,
		// replaysSessionSampleRate: 0.1,
	// For Enable Replay Session.
	// integrations: [
	// 	Sentry.replayIntegration({
	// 		maskAllText: true,
	// 		blockAllMedia: true,
	// 	}),
	// ],
	})
}